module.exports = __webpack_public_path__ + "img/4.6f5a7f48.jpg";